export enum AlertNoticeTypeEnum {
    KILOMETERS = 'KILOMETERS',
    TIME_PERIODS = 'TIME_PERIODS'
}